import React from "react";
import { pdf } from "@react-pdf/renderer";

export const usePdfRenderer = () => {
  const download = async (doc: React.ReactElement, filename: string) => {
    try {
      const blob = await pdf(doc as any).toBlob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  const print = async (doc: React.ReactElement) => {
    try {
      const blob = await pdf(doc as any).toBlob();
      const url = URL.createObjectURL(blob);

      // Create an iframe that is technically visible but hidden from view
      // This helps with browser restrictions on printing from hidden iframes
      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "0";
      iframe.src = url;

      document.body.appendChild(iframe);

      // Wait for the iframe to load
      iframe.onload = () => {
        try {
          // Small delay to ensure rendering is complete
          setTimeout(() => {
            iframe.contentWindow?.focus();
            iframe.contentWindow?.print();
          }, 500);
        } catch (error) {
          console.error("Error printing PDF:", error);
        } finally {
          // Remove iframe after a longer delay to allow print dialog to open
          setTimeout(() => {
            // Check if iframe is still in the document before removing
            if (document.body.contains(iframe)) {
              document.body.removeChild(iframe);
            }
            URL.revokeObjectURL(url);
          }, 5000); // Increased delay to be safe
        }
      };
    } catch (error) {
      console.error("Error generating PDF for print:", error);
    }
  };

  return { download, print };
};
